export default "__VITE_ASSET__BEqp7FJ1__"